export const RoleMenu: any = {
  g_CPHM_phi_admin: [
    '/product-metrics',
    '/audit',
    '/survey',
    '/simulate',
    '/survey-data',
    '/',
    '/aop-planning',
    '/aop-planning-2026',
    '/aop-planning-2027',
    '/ideas-hopper',
    '/survey-records-audits',
    '/survey-records-audits-pm-rollup',
    '/sim-planning',
    '/sim-portfolio',
    '/portfolio-gaps',
    '/aop-investment-summary',
    '/investment-return-summary',
    '/landing-page',
    '/project-list',
    '/wave-project-list',
    '/aop-mgmnt',
    '/spend-analysis-overall',
    '/spend-analysis-detailed',
    '/spend-analysis-view', 
    '/product-roadmap',   
    '/simulate2',
    '/impr-tracking-a-a',
    '/impr-tracking-a-e',
    '/impact-on-phi-a-a',
    '/impact-on-phi-a-e',
    '/spend-effectiveness',
    '/set-future-expectations',
    '/spend-allocation',
    '/config',
    '/historical-product-metrics',
    '/user-history',
    '/survey-settings'
  ],
  g_CPHM_phi_surveyonly_user: ['/survey','/','/landing-page','/product-metrics','/impr-tracking-a-a','/impact-on-phi-a-a'],
  g_CPHM_phi_phionly_user: [
    '/product-metrics',
    '/simulate',
    '/audit',
    '/survey-data',
    '/landing-page',
    '/aop-planning',
    '/aop-planning-2026',
    '/aop-planning-2027',
    '/ideas-hopper',
    '/survey-records-audits',
    '/sim-planning',
    '/sim-portfolio',
    '/portfolio-gaps',
    '/aop-investment-summary',
    '/investment-return-summary',
    '/project-list',
    '/wave-project-list',
    '/aop-mgmnt',
    '/spend-analysis-overall',
    '/spend-analysis-detailed',
    '/spend-analysis-view',
    '/product-roadmap',
    '/simulate2',
    '/impr-tracking-a-a',
    '/impact-on-phi-a-a',
    '/historical-product-metrics',
    
  ],
  g_CPHM_phi_general_user: [
    '/product-metrics',
    '/survey',
    '/simulate',
    '/audit',
    '/survey-data',
    '/landing-page',
    '/aop-planning',
    '/aop-planning-2026',
    '/aop-planning-2027',
    '/ideas-hopper',,
    '/sim-planning',
    '/sim-portfolio',
    '/portfolio-gaps',
    '/aop-investment-summary',
    '/investment-return-summary',
    '/project-list',
    '/wave-project-list',
    '/aop-mgmnt',
    '/spend-analysis-overall',
    '/spend-analysis-detailed',
    '/spend-analysis-view',
    '/simulate2',
    '/impr-tracking-a-a',
    '/impact-on-phi-a-a',
    '/product-roadmap',
    '/spend-effectiveness',
    '/historical-product-metrics',
    
  ],
    g_CPHM_phi_product_managers: [
    '/product-metrics',
    '/survey',
    '/audit',
    '/simulate',
    '/survey-data',
    '/landing-page',
    '/aop-planning',
    '/aop-planning-2026',
    '/aop-planning-2027',
    '/ideas-hopper',
    '/survey-records-audits',
    '/survey-records-audits-pm-rollup',
    '/product-roadmap',
    '/sim-planning',
    '/sim-portfolio',
    '/portfolio-gaps',
    '/aop-investment-summary',
    '/investment-return-summary',
    '/project-list',
    '/wave-project-list',
    '/aop-mgmnt',
    '/spend-analysis-overall',
    '/spend-analysis-detailed',
    '/spend-analysis-view',
    '/simulate2',
    '/impr-tracking-a-a',
    '/impact-on-phi-a-a',
    '/spend-effectiveness',
    '/historical-product-metrics',
    
    ]
};
